import React from "react";

export default function UnlimitedCTA() {
  return (
    <div className="w-full bg-redlight text-white py-20 px-6 text-center">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-light leading-relaxed mb-10">
          Unlimited orders, customers, tables, QR scans, and payments. Real-time
          order printing to Kiosks and Kitchen — fully automated.
        </h2>

        <button className="border border-white text-white font-semibold py-3 px-8 rounded-xl hover:bg-white hover:text-[#702864] transition">
          GET STARTED TODAY
        </button>

        <p className="text-sm mt-8 text-gray-200">
          Setup only takes a minute. No credit card required. Cancel anytime.
        </p>
      </div>
    </div>
  );
}
